import { db, auth, googleAuthProvider, facebookAuthProvider } from '@/firebaseInit'
const debug = require('debug')('OD::Store:User')

function generateCustomDisplayName(user) {
  return user.displayName || user.email || '--'
}

const state = {
  error: null,
  currentUser: null,
}

const getters = {}

const mutations = {
  SET_CURRENT_USER(state, { user }) {
    debug('SET_CURRENT_USER', user)
    if (user) {
      user.customDisplayName = generateCustomDisplayName(user)
    }
    state.currentUser = user
  },
  SET_LOGIN_ERROR(state, { error }) {
    debug('SET_LOGIN_ERROR', error)
    state.error = error
  },
  SET_SUPER_ADMIN(state) {
    debug('SET_SUPER_ADMIN')
    if (state.currentUser) {
      state.currentUser = Object.assign({ superadmin: true }, state.currentUser)
    }
  },
  SET_CUSTOM_NAME(state, { name }) {
    debug('SET_CUSTOM_NAME')
    if (state.currentUser) {
      state.currentUser.customDisplayName = name
    }
  },
}

const actions = {
  createUser({ commit, rootState }, { email, password }) {
    debug('createUser')
    auth
      .createUserWithEmailAndPassword(email, password)
      .then(firebaseUser => {
        debug('User Created')
        rootState.router.push({ name: 'Sports' })
      })
      .catch(error => {
        debug('User Creation Error', error.message)
        commit('SET_LOGIN_ERROR', { error: error.message })
      })
  },
  login({ commit, rootState, state }, { email, password }) {
    debug('login')
    auth
      .signInWithEmailAndPassword(email, password)
      .then(firebaseUser => {
        commit('SET_LOGIN_ERROR', { error: null })
        rootState.router.push({ name: 'Sports' })
      })
      .catch(error => {
        debug('User Login Error', error.message)
        commit('SET_LOGIN_ERROR', { error: error.message })
      })
  },
  loginGoogle({ commit, rootState, state }) {
    debug('loginGoogle')
    auth.languageCode = 'es'
    auth
      .signInWithPopup(googleAuthProvider)
      .then(firebaseUser => {
        commit('SET_LOGIN_ERROR', { error: null })
        rootState.router.push({ name: 'Sports' })
      })
      .catch(error => {
        debug('User Login Error', error.message)
        commit('SET_LOGIN_ERROR', { error: error.message })
      })
  },
  loginFacebook({ commit, rootState, state }) {
    debug('loginFacebook')
    auth.languageCode = 'es'
    auth
      .signInWithPopup(facebookAuthProvider)
      .then(firebaseUser => {
        commit('SET_LOGIN_ERROR', { error: null })
        rootState.router.push({ name: 'Sports' })
      })
      .catch(error => {
        debug('User Login Error', error.message)
        commit('SET_LOGIN_ERROR', { error: error.message })
      })
  },
  autoLogin({ commit, rootState, dispatch }) {
    debug('autoLogin')
    auth.onAuthStateChanged(async firebaseUser => {
      debug('AuthStateChanged', firebaseUser)
      if (firebaseUser) {
        if (firebaseUser.emailVerified) {
          debug('Email is verified')
        } else {
          debug('Email is not verified')
        }
        commit('SET_CURRENT_USER', { user: firebaseUser })

        const userDoc = await db
          .collection('users')
          .doc(firebaseUser.uid)
          .get()
        if (!userDoc.exists) {
          debug('Create user')
          await db
            .collection('users')
            .doc(firebaseUser.uid)
            .set({
              displayName: firebaseUser.displayName,
              email: firebaseUser.email,
              photoURL: firebaseUser.photoURL,
            })
        } else {
          const user = userDoc.data()
          debug('User already exists', user)
          if (
            (firebaseUser.displayName !== '' && user.displayName !== firebaseUser.displayName) ||
            (firebaseUser.displayphotoURLName !== '' && user.photoURL !== firebaseUser.photoURL)
          ) {
            debug('Update user data exists', user)
            await db
              .collection('users')
              .doc(firebaseUser.uid)
              .update({
                displayName: firebaseUser.displayName,
                email: firebaseUser.email,
                photoURL: firebaseUser.photoURL,
              })
          }

          if (user.customName) {
            commit('SET_CUSTOM_NAME', { name: user.customName })
          }

          if (user.superadmin) {
            commit('SET_SUPER_ADMIN')
          }
        }
      }
    })
  },
  logout({ commit, rootState, dispatch }) {
    debug('logout')
    auth.signOut().then(data => {
      commit('SET_CURRENT_USER', { user: null })
      rootState.router.push({ name: 'Sports' })
    })
  },
  cleanError({ commit, rootState }) {
    debug('cleanError')
    commit('SET_LOGIN_ERROR', { error: '' })
  },
}

export default { namespaced: true, state, mutations, actions, getters }
